import { Chip } from "@mui/material";
import React from "react";

export default function ChipStatus({ type, title, size }) {
  let color = [
    {
      name: "1",
      color: "#faba02",
      backColor: "#f7eccd",
    },
    {
      name: "2",
      color: "#37cf37",
      backColor: "#d5f5d5",
    },
    {
      name: "8",
      color: "#929bff",
      backColor: "#dee1ff",
    },
    {
      name: "3",
      color: "#0697ff",
      backColor: "#def1ff",
    },
    {
      name: "4",
      color: "#ff2015",
      backColor: "#ffb2ae",
    },
    {
      name: "5",
      color: "#929bff",
      backColor: "#dee1ff",
    },
    {
      name: "6",
      color: "#ff2015",
      backColor: "#ffb2ae",
    },
    {
      name: "7",
      color: "#929bff",
      backColor: "#dee1ff",
    },
    {
      name: "10",
      color: "#faba02",
      backColor: "#f7eccd",
    },
    {
      name: "11",
      color: "#0697ff",
      backColor: "#def1ff",
    },
    {
      name: "12",
      color: "#37cf37",
      backColor: "#d5f5d5",
    },
    {
      name: "31",
      color: "#37cf37",
      backColor: "#d5f5d5",
    },

    {
      name: "CONFIRM",
      color: "#37cf37",
      backColor: "#d5f5d5",
    },
    {
      name: "PREPARE",
      color: "#0697ff",
      backColor: "#def1ff",
    },
    {
      name: "In Progress",
      color: "#0697ff",
      backColor: "#def1ff",
    },
    {
      name: "EDITING",
      color: "#0697ff",
      backColor: "#def1ff",
    },
    {
      name: "PARTIAL",
      color: "#faba02",
      backColor: "#f7eccd",
    },
    {
      name: "CANCEL",
      color: "#ff2015",
      backColor: "#ffb2ae",
    },
    {
      name: "NO-REPORT",
      color: "#37cf37",
      backColor: "#d5f5d5",
    },
    {
      name: "รายงานผลแล้ว",
      color: "#fff",
      backColor: "rgba(30, 143, 86, 0.8)",
    },
    {
      name: "รอยืนยันผล",
      color: "#929bff",
      backColor: "#dee1ff",
    },
    {
      name: "รายงานบางส่วน",
      color: "#fff",
      backColor: "rgba(37, 139, 165, 0.8)",
    },
    {
      name: "กำลังดำเนินการ",
      color: "#fff",
      backColor: "#9e9e9e",
    },
    {
      name: "ยกเลิก",
      color: "#ff2015",
      backColor: "#ffb2ae",
    },
  ];

  let theme = color.find((opt) => opt.name === type);

  return (
    <Chip
      label={title}
      size={size ? size : "small"}
      sx={{
        backgroundColor: theme ? theme.backColor : "#999",
        color: theme ? theme.color : "#fff",
        fontWeight: "bold",
      }}
    />
  );
}
